module.exports = __webpack_public_path__ + "img/jrkj.ca944e0b.svg";